// extracted by mini-css-extract-plugin
module.exports = {"registerContainer":"Register_registerContainer__1rjr-","registerForm":"Register_registerForm__3capi"};